import React from "react";
import "../styles/footer.css";
import LinkedIn from "../assets/svgs/Linkedin.svg";
import Twitter from "../assets/svgs/Twitter.svg";
import Instagram from "../assets/svgs/Instagram.svg";
import Facebook from "../assets/svgs/Facebook.svg";

export const Footer = () => {
    return (
        <>
            <footer className="primary-footer">
                <div className="footer-wrapper">
                    <div className="about">
                        <h2>Shuttle <span style={{color: "rgba(4, 159, 90, 1)"}}>9<span style={{color: "rgba(166, 181, 1, 1)"}}>j</span>a</span></h2>
                        <p>
                        Inter-state transportation agency for booking bus rides
                        </p>
                        <div className="socials">
                            <a href="http://"><img src = {LinkedIn} alt="LinkedIn"/></a>
                            <a href="http://"><img src = {Twitter} alt="Twitter"/></a>
                            <a href="http://"><img src = {Instagram} alt="Instagram"/></a>
                            <a href="http://"><img src = {Facebook} alt="Facebook"/></a>
                        </div>
                        <div className="contact">
                            <a href="mailto:">hello@shuttle9ja.com</a>
                            <p>+234 903 7362 896</p>
                        </div>
                    </div>
                    <ul className="navigation">
                        <li>Company
                            <ul>
                                <li>About us</li>
                                <li>Careers</li>
                                <li>Partners</li>
                                <li>Transport Companies</li>
                            </ul>
                        </li>
                        <li>Legal
                            <ul>
                                <li>Terms & Conditions</li>
                                <li>Privacy policy</li>
                            </ul>
                        </li>
                        <li>Support
                            <ul>
                                <li>FAQS</li>
                                <li>Contact</li>
                            </ul>
                        </li>
                    </ul>
                    <div className="sign-up">
                        <h6>
                            Do you enjoy bus ride offers?
                        </h6>
                        <p>
                            Sign up to receive enjoyable deals
                        </p>
                        <div className="email-sign-up">
                            <input type="email" name="" id="" placeholder="user@email.com"/>
                            <button type="submit">Sign up</button>
                        </div>
                    </div>
                    <footer>
                        <p>Copyright © Shuttle9ja. All rights reserved.</p>
                        <p>Designed by Alpha-tribe.</p>
                    </footer>
                </div>
            </footer>

        </>
    )
}

export default Footer;